import React, { useEffect, useRef, useState } from "react";
import * as THREE from 'three'
import { OrbitControls } from "../OrbitControls";
import { loadModel } from "../ModelLoader"
import { CSS2DRenderer, CSS2DObject } from 'three/addons/renderers/CSS2DRenderer.js';
import gsap from 'gsap'
import ReservationPopup from "../ReservationPopup";
import FloorSwitcher from "../FloorSwitcher"
import "./styles.scss"
import TitleScreen from "../TitleScreen";
import { auth } from '../../Config/firebase'; // Make sure to import your Firebase auth configuration
import { onAuthStateChanged } from 'firebase/auth';
import Header from "../Header";
import ReservationForm from "../ReservationForm";
import { firestore } from "../../Config/firebase"; // Adjust the import path
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import RoomDetails from "../RoomDetails";
import Loading from "../Loading";
import AlertMaker from "../AlertMaker";



function FloorPlanExperience() {

    const canvasRef = useRef()
    const [selectedRoom, setSelectedRoom] = useState("")
    const [selectedRoomUserData, setSelectedRoomUserData] = useState({})
    const [showTitleScreen, setShowTitleScreen] = useState(true)
    const [showPopUp, setShowPopUp] = useState(false)
    const [showDetails, setShowDetails] = useState(false)
    const [showForm, setShowForm] = useState(false)
    const [user, setUser] = useState(null)
    const [loading, setLoading] = useState(true)
    const [allReservations, setReservations] = useState([])
    const [alertMakerContent, setAlertMakerContent] = useState("")
    const [userName, setUserName] = useState("")
    const [editForm, setEditForm] = useState(false)

    var scene, camera, renderer, controls, bbox, min_x, max_x, min_y, max_y, labelRenderer, raycaster, pointer;

    const currentFloor = useRef()
    const floor1 = useRef()
    const floor2 = useRef()
    const labelRendererContainer = useRef()


    useEffect(() => {
        if (user) {
            init()
            render()
            window.addEventListener("resize", handleResize)

            return (() => {
                window.removeEventListener("resize", handleResize)
            })
        }
    }, [user])



    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                gsap.to('.title-screen', { transform: 'translateY(100%)', duration: 0 })
                setUser(user); // Set the user in state
                try {
                    const userDocRef = doc(firestore, 'users', auth.currentUser.uid);
                    const userDoc = await getDoc(userDocRef);

                    if (userDoc.exists()) {
                        setUserName(userDoc.data().name || 'User'); // Use 'User' as fallback
                    } else {
                        console.log('No such document!');
                    }
                } catch (error) {
                    console.error('Error fetching user name:', error);
                }
            } else {
                setUser(null); // Clear user state
            }
        });

        // Clean up the subscription on component unmount
        return () => unsubscribe();
    }, []);


    const getAllReservations = async () => {
        try {
            // Reference to the 'reservations' collection
            const reservationsCollection = collection(firestore, "reservations");

            // Fetch all documents from the collection
            const querySnapshot = await getDocs(reservationsCollection);

            // Map through the documents and format the data
            const reservations = querySnapshot.docs.map((doc) => ({
                id: doc.id, // Include the document ID
                ...doc.data(), // Spread the document data
            }));
            setReservations(reservations)

            return reservations; // Return the reservations array
        } catch (error) {
            console.error("Error fetching reservations:", error);
            throw error; // Re-throw error for further handling if needed
        }
    };

    function arrayContainsObjectWithValue(array, attribute, value) {
        return array.some(obj => obj[attribute] === value);
    }


    const colorRoomsWithReservation = (reservations) => {
        if (floor1.current) {
            floor1.current.children[0].children.map((v) => {

                if (!arrayContainsObjectWithValue(reservations, "room", v.name)) {
                    v.material.color = new THREE.Color(v.userData.originalColor)
                    v.userData.color = new THREE.Color(v.userData.originalColor)
                    v.userData.booked = false
                }
            })

            floor2.current.children[0].children.map((v) => {

                if (!arrayContainsObjectWithValue(reservations, "room", v.name)) {
                    v.material.color = new THREE.Color(v.userData.originalColor)
                    v.userData.color = new THREE.Color(v.userData.originalColor)
                    v.userData.booked = false
                }
            })

            reservations.map((v) => {
                var object = floor1.current.getObjectByName(v.room) ? floor1.current.getObjectByName(v.room) : floor2.current.getObjectByName(v.room)
                if (v.typeOfRoom.includes("Semi Private")) {
                    if (v.person2.name) {
                        object.material.color = new THREE.Color(0x9F9379)
                        object.userData.color = new THREE.Color(0x9F9379)
                    }
                    else {
                        object.material.color = new THREE.Color(0xece0d1)
                        object.userData.color = new THREE.Color(0xece0d1)
                    }
                }
                else if (v.typeOfRoom.includes("Private")) {
                    object.material.color = new THREE.Color(0xD9AE8F)
                    object.userData.color = new THREE.Color(0xD9AE8F)
                }
                object.userData.booked = true
            })

            setLoading(false)
        }
    }

    useEffect(() => {
        colorRoomsWithReservation(allReservations)
    }, [allReservations])


    async function init() {
        // Scene
        scene = new THREE.Scene();
        scene.background = new THREE.Color(0xFAFAFA)
        // Camera
        camera = new THREE.PerspectiveCamera(
            10,
            window.innerWidth / window.innerHeight,
            20,
            300
        );

        camera.position.set(0, 0, 250)


        // Renderer
        renderer = new THREE.WebGLRenderer({ antialias: true, canvas: canvasRef.current });
        renderer.setSize(window.innerWidth, window.innerHeight);
        renderer.shadowMap.enabled = true;
        renderer.toneMappingExposure = 1.0;





        const ambientLight = new THREE.AmbientLight(0xffffff, 3); // Soft white light
        scene.add(ambientLight);

        var floor1Model = await loadModel("models/Floor1.glb")
        var floor2Model = await loadModel("models/Floor2.glb")

        floor1.current = new THREE.Group()
        floor2.current = new THREE.Group()
        floor1.current.add(floor1Model)
        floor2.current.add(floor2Model)


        floor1.current.rotation.x = Math.PI / 2
        floor2.current.rotation.x = Math.PI / 2

        scene.add(floor1.current)
        scene.add(floor2.current)

        labelRenderer = new CSS2DRenderer();
        labelRenderer.setSize(window.innerWidth, window.innerHeight);
        labelRenderer.domElement.className = "label-renderer"
        labelRendererContainer.current.appendChild(labelRenderer.domElement);


        //Orbit controls
        controls = new OrbitControls(camera, labelRenderer.domElement);
        controls.mouseButtons = {
            LEFT: THREE.MOUSE.PAN,
            MIDDLE: THREE.MOUSE.PAN,
            RIGHT: THREE.MOUSE.PAN
        }

        controls.touches = {
            ONE: THREE.TOUCH.PAN,
            TWO: THREE.TOUCH.PAN
        }

        controls.minDistance = 100
        controls.maxDistance = 250

        addRoomLabels()

        raycaster = new THREE.Raycaster();
        pointer = new THREE.Vector2();

        showFloor1()

        labelRenderer.domElement.addEventListener("click", onClick)
        // window.addEventListener("mousedown", onClick)
        labelRenderer.domElement.addEventListener('pointermove', onPointerMove);

        getAllReservations()
    }




    function addRoomLabels() {
        floor1.current.children[0].traverse((v) => {
            if (v.isMesh) {
                if (v.name !== "Plane") {
                    const roomNumber = document.createElement('div');
                    roomNumber.className = 'room-number';
                    roomNumber.innerHTML = v.name;

                    const roomNumberLabel = new CSS2DObject(roomNumber);
                    roomNumberLabel.name = "roomNumberLabel"
                    roomNumberLabel.position.copy(v.position)
                    floor1.current.add(roomNumberLabel)
                }
            }
        })

        floor2.current.children[0].traverse((v) => {
            if (v.isMesh) {
                if (v.name !== "Plane") {
                    const roomNumber = document.createElement('div');
                    roomNumber.className = 'room-number';
                    roomNumber.innerHTML = v.name;

                    const roomNumberLabel = new CSS2DObject(roomNumber);
                    roomNumberLabel.name = "roomNumberLabel"
                    roomNumberLabel.position.copy(v.position)
                    floor2.current.add(roomNumberLabel)
                }
            }
        })
    }

    function onPointerMove(event) {
        if (pointer) {
            pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
            pointer.y = - (event.clientY / window.innerHeight) * 2 + 1;

            raycaster.setFromCamera(pointer, camera);

            const intersects = raycaster.intersectObjects(currentFloor.current.children[0].children);


            if (intersects[0]) {
                if (!intersects[0].object.userData.booked) {
                    currentFloor.current.children[0].traverse((v) => {

                        if (v.isMesh && v.name !== "Plane" && v.name !== intersects[0].object.name) {
                            gsap.to(v.material.color, { r: v.userData.color.r, g: v.userData.color.g, b: v.userData.color.b, duration: 0.3 })
                        }
                    })
                    if (intersects[0].object.name !== "Plane") {
                        gsap.to(intersects[0].object.material.color, { r: 0.796078431372549, g: 0.615686274509804, b: 0.49411764705882355, duration: 0.3 })
                    }

                }
                else {
                    currentFloor.current.children[0].traverse((v) => {
                        if (v.isMesh && v.name !== "Plane") {
                            gsap.to(v.material.color, { r: v.userData.color.r, g: v.userData.color.g, b: v.userData.color.b, duration: 0.3 })
                        }
                    })
                }
            }
        }

    }


    function showFloor1() {
        floor1.current.traverse((v) => {
            v.visible = true
            if (v.name == "roomNumberLabel") {
                v.element.display = "block"
            }
        })

        floor2.current.traverse((v) => {
            v.visible = false
            if (v.name == "roomNumberLabel") {
                v.element.display = "none"
            }
        })

        currentFloor.current = floor1.current
        currentFloor.current.name = "Ground"
    }

    function showFloor2() {
        floor1.current.traverse((v) => {
            v.visible = false
            if (v.name == "roomNumberLabel") {
                v.element.display = "none"
            }
        })

        floor2.current.traverse((v) => {
            v.visible = true
            if (v.name == "roomNumberLabel") {
                v.element.display = "block"
            }
        })

        currentFloor.current = floor2.current
        currentFloor.current.name = "First"
    }


    function onClick(event) {

        pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
        pointer.y = - (event.clientY / window.innerHeight) * 2 + 1;

        raycaster.setFromCamera(pointer, camera);

        const intersects = raycaster.intersectObjects(currentFloor.current.children[0].children);
        if (intersects[0] && intersects[0].object.name !== "Plane") {
            setSelectedRoom(intersects[0].object.name)
            setSelectedRoomUserData(intersects[0].object.userData)
            if (!intersects[0].object.userData.booked) {
                setShowPopUp(true)
            }
            else {
                setShowDetails(true)
            }
        }
    }

    function switchGround() {
        document.getElementById("ground").classList.add("active")
        document.getElementById("first").classList.remove("active")
        showFloor1()
    }

    function switchFirst() {
        document.getElementById("first").classList.add("active")
        document.getElementById("ground").classList.remove("active")
        showFloor2()
    }


    //Animation loop
    function render() {
        requestAnimationFrame(render);
        renderer.render(scene, camera);
        if (labelRenderer) {
            labelRenderer.render(scene, camera);
        }
    }

    //Resize renderer on screen resize
    function handleResize() {
        const width = window.innerWidth;
        const height = window.innerHeight;

        camera.aspect = width / height;
        camera.updateProjectionMatrix();
        renderer.setSize(width, height);
        labelRenderer.setSize(width, height);
    }

    function closePopup() {
        setShowPopUp(false)
    }

    function closeForm() {
        setShowForm(false)
    }

    function showReservationForm(value) {
        setShowForm(true)
        if (value) {
            setEditForm(value)
        }
    }

    function closeDetails() {
        setShowDetails(false)
    }

    function closeTitleScreen() {
        gsap.to('.title-screen', {
            transform: 'translateY(100%)', ease: 'power3.out', duration: 2, onComplete: () => {
                setShowTitleScreen(false)
            }
        })
    }

    function openTitleScreen() {
        setShowTitleScreen(true)
        document.querySelector(".title-screen").style.transform = "translateY(100%)"
        setTimeout(() => {
            gsap.fromTo('.title-screen', { transform: 'translateY(100%)' }, { transform: 'translateY(0%)', ease: 'power3.out', duration: 2 })
        }, 200);
    }

    function changeAlertMakerContent(content) {
        setAlertMakerContent(content)
        setTimeout(() => {
            setAlertMakerContent("")
        }, 3000);
    }

    function resetEditForm() {
        setEditForm(false)
    }



    return (
        <div>
            <TitleScreen closeTitleScreen={closeTitleScreen} user={user} />
            {user && <>
                <Header userName={userName} openTitleScreen={openTitleScreen} />
                <canvas className="canvas" ref={canvasRef}></canvas>
                <FloorSwitcher switchGround={switchGround} switchFirst={switchFirst} />

                {showPopUp && <ReservationPopup selectedRoom={selectedRoom} closePopup={closePopup} showForm={showReservationForm} floor={currentFloor.current.name} selectedRoomUserData={selectedRoomUserData} />}
                {showForm && <ReservationForm resetEditForm={resetEditForm} editForm={editForm} closeDetails={closeDetails} userName={userName} closeForm={closeForm} floor={currentFloor.current.name} selectedRoom={selectedRoom} getAllReservations={getAllReservations} changeAlertMakerContent={changeAlertMakerContent} />}
                {showDetails && <RoomDetails selectedRoom={selectedRoom} allReservations={allReservations} closePopup={closeDetails} showReservationForm={showReservationForm} getAllReservations={getAllReservations} selectedRoomUserData={selectedRoomUserData} changeAlertMakerContent={changeAlertMakerContent} />}
                {alertMakerContent && <AlertMaker content={alertMakerContent} />}
                <div className="label-renderer-container" ref={labelRendererContainer}></div>
                {loading && <Loading />}
            </>}

        </div>

    )
}

export default FloorPlanExperience